import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star } from 'lucide-react';
export function AboutMe() {
  return <section id="sobre-mi" className="py-24 relative overflow-hidden" data-id="element-15">
      {/* Soft background image */}
      <div className="absolute inset-0 z-0" data-id="element-16">
        <img src="https://cdn.magicpatterns.com/uploads/fbQ74FsC3s2dT3V3tvS8GU/2.png" alt="" className="w-full h-full object-cover object-left" aria-hidden="true" data-id="element-17" />
        <div className="absolute inset-0 bg-white/[0.72]" data-id="element-18" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-19">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-20">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-21">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/dvjQYywHnqpQT3eyuDknVp/imagen_2.png" alt="Vanii" className="w-full h-full object-cover object-top" style={{
              filter: 'brightness(1.04) contrast(1.02)'
            }} data-id="element-23" />
              <div className="absolute inset-0 bg-violet-800/5 mix-blend-overlay" data-id="element-24"></div>
            </div>

            {/* Experience Badge */}
            <motion.div initial={{
            scale: 0
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5,
            type: 'spring'
          }} className="absolute -bottom-6 -right-6 lg:bottom-10 lg:-right-10 bg-white p-6 rounded-2xl shadow-xl border border-violet-50" data-id="element-25">
              <div className="flex items-center gap-4" data-id="element-26">
                <div className="bg-amber-100 p-3.5 rounded-full text-amber-600" data-id="element-27">
                  <Star size={28} className="fill-current" data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <p className="text-3xl font-serif font-bold text-stone-900" data-id="element-30">
                    +15
                  </p>
                  <p className="text-sm text-stone-500 font-medium uppercase tracking-wider" data-id="element-31">
                    Años de dedicación
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 space-y-6" data-id="element-32">
            <div className="flex items-center gap-3 text-violet-600 mb-4" data-id="element-33">
              <Heart size={20} className="fill-current opacity-50" data-id="element-34" />
              <span className="text-sm font-medium uppercase tracking-widest" data-id="element-35">
                Mi Historia
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-serif text-stone-900 leading-tight" data-id="element-36">
              Un camino de{' '}
              <span className="text-violet-600 italic" data-id="element-37">luz y sanación</span>
            </h2>

            <div className="space-y-4 text-stone-600 font-light leading-relaxed text-lg" data-id="element-38">
              <p data-id="element-39">
                Desde pequeña, comencé a escuchar y percibir información
                espiritual, conectando especialmente con mi abuelo fallecido.
                Estas experiencias generaron miedo en mi entorno, lo que provocó
                que reprimiera mi «don» durante un tiempo.
              </p>
              <p data-id="element-40">
                Con los años, decidí enfrentarme a ese miedo, desarrollando mi
                mediumnidad y convirtiéndola en mi propósito de vida. Comencé
                con el tarot a los 9 años, y a partir de los 11 las «conexiones»
                se hicieron más fuertes.
              </p>
              <p data-id="element-41">
                He sido autodidacta y he seguido un camino profundo de
                autoconocimiento, sanación y evolución personal. Me he formado
                en diversas disciplinas para ofrecer un acompañamiento integral:
              </p>
            </div>

            <div className="grid grid-cols-2 gap-y-3 gap-x-6 pt-4" data-id="element-42">
              {['Yoga (España e India)', 'Reiki Atlante', 'Terapia Transpersonal', 'Constelaciones Familiares', 'Registros Akáshicos', 'Magia Angelical', 'Hipnosis', 'Terapia Bioneuroemoción', 'PNL', 'Biomagnetismo'].map((item, index) => <div key={index} className="flex items-center gap-2 text-stone-700" data-id="element-43">
                  <div className="w-1.5 h-1.5 rounded-full bg-amber-400" data-id="element-44" />
                  <span className="text-sm md:text-base" data-id="element-45">{item}</span>
                </div>)}
            </div>

            <div className="pt-6" data-id="element-46">
              <p className="text-xl font-serif text-violet-700 italic" data-id="element-47">
                "Hoy acompaño a otras personas en su propio proceso de
                transformación, desde el amor y sin juicios."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}